import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import LocalGroceryStoreOutlinedIcon from '@mui/icons-material/LocalGroceryStoreOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './itemlists.css';

const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

const isStaff = JSON.parse(localStorage.getItem('is_staff'));

function ItemLists({ type, count = 0 }) {
    const { t, i18n } = useTranslation();

    let data;

    const displayCount = isStaff ? count : 0;

    switch (type) {
        case 'user':
            data = {
                title: t('item_preparing'),
                isMoney: false,
                link: t('view_details'),
                linkto: '/orders?status=preparing',
                icon: <PermIdentityIcon />,
            };
            break;

        case 'orders':
            data = {
                title: t('item_delivered'),
                isMoney: false,
                link: t('view_details'),
                linkto: '/orders?status=served',
                icon: <LocalGroceryStoreOutlinedIcon />,
            };
            break;

        case 'products':
            data = {
                title: t('item_paid'),
                isMoney: true,
                link: t('view_details'),
                linkto: '/orders?status=paid',
                icon: <PaidOutlinedIcon />,
            };
            break;

        case 'balance':
            data = {
                title: t('item_canceled'),
                isMoney: true,
                link: t('view_details'),
                linkto: '/orders?status=cancelled',
                icon: <AttachMoneyOutlinedIcon />,
            };
            break;

        default:
            data = {
                title: '',
                isMoney: false,
                link: '',
                linkto: '/orders',
                icon: null,
            };
            break;
    }

    return (
        <div className="item_listss">
            <div className="name">
                <p>{data.title}</p>
            </div>

            <div className="counts">
                {Number(displayCount ?? 0).toLocaleString(
                    i18n.language === 'fa' ? 'fa-IR' : 'en-US'
                )}
            </div>

            <Link to={data.linkto} className="see_item">
                <p>{data.link}</p>
            </Link>
        </div>
    );
}

export default ItemLists;
